import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  ScrollView,
} from '../utils/webComponents';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from '../hooks/useTranslation';

const TermsOfServiceScreen = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: theme.background }]}>
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={[styles.scrollContent, { alignItems: 'center' }]}
      >
        <View style={styles.content}>
          <Text style={[styles.title, { color: theme.text }]}>
            {t('terms.title')}
          </Text>
          <Text style={[styles.lastUpdated, { color: theme.textSecondary }]}>
            {t('terms.lastUpdated')}: {new Date().toLocaleDateString()}
          </Text>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('terms.introduction')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('terms.introductionText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('terms.acceptanceOfTerms')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('terms.acceptanceOfTermsText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('terms.descriptionOfService')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('terms.descriptionOfServiceText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('terms.userAccounts')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('terms.userAccountsText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('terms.acceptableUse')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('terms.acceptableUseText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('terms.privacy')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('terms.privacyText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('terms.termination')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('terms.terminationText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('terms.indemnification')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('terms.indemnificationText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('terms.governingLaw')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('terms.governingLawText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('terms.changesToTerms')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('terms.changesToTermsText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('terms.contactInformation')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('terms.contactInformationText').replace(/\n\n/g, '\n').replace(/\n/g, ' ')}
            </Text>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 40,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  content: {
    maxWidth: 700,
    width: 'calc(100% - 48px)',
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 40,
  },
  title: {
    fontSize: 32,
    fontWeight: '700',
    marginBottom: 8,
    textAlign: 'center',
    display: 'block',
  },
  lastUpdated: {
    fontSize: 14,
    marginBottom: 40,
    textAlign: 'center',
    display: 'block',
  },
  section: {
    marginBottom: 32,
  },
  sectionTitle: {
    fontSize: 22,
    fontWeight: '600',
    marginBottom: 12,
    textAlign: 'center',
    display: 'block',
  },
  paragraph: {
    fontSize: 16,
    lineHeight: '1.6',
    textAlign: 'center',
    marginTop: 0,
    marginBottom: 16,
    marginLeft: 0,
    marginRight: 0,
    padding: 0,
  },
});

export default TermsOfServiceScreen;
